// Action Types
export const FETCH_DEPARTMENTS_REQUEST = 'FETCH_DEPARTMENTS_REQUEST';
export const FETCH_DEPARTMENTS_SUCCESS = 'FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENTS_FAILURE = 'FETCH_DEPARTMENTS_FAILURE';

export const CREATE_DEPARTMENT_REQUEST = 'CREATE_DEPARTMENT_REQUEST';
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_FAILURE = 'CREATE_DEPARTMENT_FAILURE';

export const UPDATE_DEPARTMENT_REQUEST = 'UPDATE_DEPARTMENT_REQUEST';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const UPDATE_DEPARTMENT_FAILURE = 'UPDATE_DEPARTMENT_FAILURE';

export const DELETE_DEPARTMENT_REQUEST = 'DELETE_DEPARTMENT_REQUEST';
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';
export const DELETE_DEPARTMENT_FAILURE = 'DELETE_DEPARTMENT_FAILURE';

// Action Creators
export const fetchDepartmentsRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
      type: FETCH_DEPARTMENTS_REQUEST,
      payload: { projectId, page, limit, search },
      
    };
    
  };
export const fetchDepartmentsSuccess = (departments) => ({ type: FETCH_DEPARTMENTS_SUCCESS, payload: departments });
export const fetchDepartmentsFailure = (error) => ({ type: FETCH_DEPARTMENTS_FAILURE, payload: error });

export const createDepartmentRequest = (data) => ({ type: CREATE_DEPARTMENT_REQUEST, payload: data });
export const createDepartmentSuccess = (department) => ({ type: CREATE_DEPARTMENT_SUCCESS, payload: department });
export const createDepartmentFailure = (error) => ({ type: CREATE_DEPARTMENT_FAILURE, payload: error });

export const updateDepartmentRequest = (id, data, projectId) => ({ type: UPDATE_DEPARTMENT_REQUEST, payload: { id, data, projectId } });
export const updateDepartmentSuccess = (department) => ({ type: UPDATE_DEPARTMENT_SUCCESS, payload: department });
export const updateDepartmentFailure = (error) => ({ type: UPDATE_DEPARTMENT_FAILURE, payload: error });

export const deleteDepartmentRequest = (id, projectId) => ({ type: DELETE_DEPARTMENT_REQUEST, payload: { id, projectId } });
export const deleteDepartmentSuccess = (id) => ({ type: DELETE_DEPARTMENT_SUCCESS, payload: id });
export const deleteDepartmentFailure = (error) => ({ type: DELETE_DEPARTMENT_FAILURE, payload: error });
